import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const PremiunText = styled(Text)`
  color: ${(props) => (props.isBoldText ? "#040222" : "#5b5675")};
  font-size: 14px;
  font-weight: ${(props) => (props.isBoldText ? 600 : 400)};
  line-height: 20px;

  @media (min-width: 767px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const PremiunValue = styled(Text)`
  color: #040222;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.isBoldText ? 600 : 400)};
  line-height: 20px;

   color: ${({ isDiscount }) => {
     return isDiscount ? "#0FA457" : "#040222";
   }};
    
  }}
`;

export const PremiumHeading = styled(Text)`
  color: #040222;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ButtonWrapper = styled(Flex)`
  margin-top: 20px;
  height: 48px;
`;

export const PremiunCueText = styled(Text)`
  color: #5b5675;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
`;

export const NetPremiunText = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`;

export const DashedDivider = styled.div`
  height: 1px;
  border-top: 1px dotted #efe9fb;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
